import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

import styles from './styles.module.scss';

const CalibrationKindSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { calibrationKindItems, noItemsText } = useData();

    const handleClick = (calibrationKind: Item) => {
        onChange(calibrationKind);
        onClose?.(calibrationKind);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                className={styles.selectPanel}
                isSearchable={false}
                itemSelected={value}
                items={calibrationKindItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default CalibrationKindSelectPanelField;
